import script from "./VuetableFieldCheckboxMixin.vue?vue&type=script&lang=js"
export * from "./VuetableFieldCheckboxMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__